import {z} from 'zod';

import {BaseVoidRequestSchema} from '@dms/api/shared';

const BaseServiceOrderVariantSchema = z.object({
  id: z.string(),
  authorizationProfileId: z.string().nullish(),
  serviceCaseTypeId: z.string().nullish(),
  serviceOrderTypeId: z.string().nullish(),
  name: z.string(),
  note: z.string().nullish(),
  priceType: z.string().nullish(),
  priceTypeRatio: z.number().nullish(),
  rateType: z.string().nullish(),
  rateTypeRatio: z.number().nullish(),
  isUnitPriceWithVat: z.boolean().nullish(),
  defaultCustomerId: z.string().nullish(),
  isChangeableDefaultCustomer: z.boolean().nullish(),
  suffix: z.string().nullish(),
  minimalMaterialMargin: z.number().nullish(),
  minimalWorkMargin: z.number().nullish(),
  branchId: z.string().nullish(),
});
export type BaseServiceOrderVariant = z.infer<typeof BaseServiceOrderVariantSchema>;

/**
 * GET
 */
export const GetServiceOrderVariantsRequestSchema = BaseVoidRequestSchema;
export type GetServiceOrderVariantsRequest = z.infer<typeof GetServiceOrderVariantsRequestSchema>;

export const GetServiceOrderVariantsResponseSchema = z.object({
  serviceOrderVariants: z.object({
    serviceOrderVariant: z.array(BaseServiceOrderVariantSchema),
  }),
});
export type GetServiceOrderVariantsResponse = z.infer<typeof GetServiceOrderVariantsResponseSchema>;
